import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { KpiCard, ToggleBarChart, ProgressSummaryCard, CohortUsersDrawer } from '../../../common/analytics';
import EnrollmentFunnel from './EnrollmentFunnel';
import {
    KPI_ICONS,
    KPI_DRILLDOWN,
    USER_ADOPTION_FREQUENCIES,
    USER_ADOPTION_SERIES,
} from '../../dashboard.constants';
import CardSkeleton from '../../../common/cardSkeleton/CardSkeleton';
import styles from './styles/adoption-section.module.scss';

function AdoptionSection({
    kpis = [],
    userAdoption,
    userAdoptionMetrics = {},
    onUserAdoptionFrequencyChange,
    adoptionSummary,
    enrollmentFunnel = {},
    enrollmentSummary,
    cohort = {},
    loading = false,
}) {
    const { activeFrequency = 'monthly', data = {}, loading: chartLoading = false } = userAdoptionMetrics;
    const chartDataLoading = chartLoading && data[activeFrequency] === undefined;

    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>Adoption</Text>

            {loading ? (
                <>
                    <div className={styles.kpiRow}>
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                    </div>
                    <div className={styles.splitRow}>
                        <CardSkeleton minHeight={420} rows={6} />
                        <CardSkeleton minHeight={320} rows={5} />
                    </div>
                    <div className={styles.splitRow}>
                        <CardSkeleton minHeight={420} rows={6} />
                        <CardSkeleton minHeight={320} rows={5} />
                    </div>
                </>
            ) : (
                <>
            <div className={styles.kpiRow}>
                {kpis.map((kpi) => {
                    const drilldown = kpi.drilldown || KPI_DRILLDOWN[kpi.key];
                    return (
                        <KpiCard
                            key={kpi.key}
                            label={kpi.label}
                            value={kpi.value}
                            variant={kpi.variant}
                            conversionRate={kpi.conversionRate}
                            icon={KPI_ICONS[kpi.key]}
                            onClick={drilldown ? () => cohort.onOpen(drilldown) : undefined}
                        />
                    );
                })}
            </div>

            <div className={styles.splitRow}>
                <ToggleBarChart
                    title={userAdoption.title}
                    subtitle={userAdoption.subtitle}
                    toggles={USER_ADOPTION_FREQUENCIES}
                    activeToggle={activeFrequency}
                    onToggleChange={onUserAdoptionFrequencyChange}
                    series={USER_ADOPTION_SERIES}
                    data={data}
                    loading={chartDataLoading}
                />
                <ProgressSummaryCard
                    title={adoptionSummary.title}
                    subtitle={adoptionSummary.subtitle}
                    items={adoptionSummary.items}
                />
            </div>

            <div className={styles.splitRow}>
                <div className={styles.funnelWrapper}>
                    <EnrollmentFunnel
                        title={enrollmentFunnel.title}
                        subtitle={enrollmentFunnel.subtitle}
                        steps={enrollmentFunnel.steps}
                        groups={enrollmentFunnel.groups}
                        cohort={cohort}
                        loading={enrollmentFunnel.loading}
                    />
                </div>
                <ProgressSummaryCard
                    title={enrollmentSummary.title}
                    subtitle={enrollmentSummary.subtitle}
                    items={enrollmentSummary.items}
                />
            </div>
                </>
            )}

            <CohortUsersDrawer cohort={cohort} />
        </section>
    );
}

export default AdoptionSection;
